module.exports = __webpack_public_path__ + "img/goods-b.f778ac13.svg";